import { TASK_PRIORITY } from '@common/types';
import { theme } from '@store';

export const getPriorityColor = (priority: TASK_PRIORITY) => {
  switch (priority) {
    case TASK_PRIORITY.OVERDUE:
    case TASK_PRIORITY.URGENT:
      return theme.palette.error.main;
    case TASK_PRIORITY.HIGH:
      return theme.palette.warning.main;
    case TASK_PRIORITY.MEDIUM:
      return theme.palette.info.main;
    case TASK_PRIORITY.LOW:
    default:
      return 'rgba(97, 97, 97, 0.9)';
  }
};
